import * as React from "react";
import { makeStyles, useMediaQuery, useTheme, Typography, Box } from "@material-ui/core";
import moment from "moment";
import { useRouter } from "next/router";

import { Grid } from "ui/grid/Grid";
import { formatDate } from "helpers/formatDate";
import { CollectFunnelContext } from "components/collectFunnel/CollectFunnelProvider";
import { STEP_ADDRESS_URL } from "components/collectFunnel/constants";
import Smile from "./assets/smile.svg";
import YellowDash from "./assets/yellowDash.svg";
import { CollectProductRecap } from "components/collect/CollectProductRecap";

export const CollectFunnelConfirmationStep = () => {
  const [state] = React.useContext(CollectFunnelContext);
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down("sm"));
  const classes = useStyles();
  const router = useRouter();
  const title = "Votre demande de RDV sera bientôt confirmée !";

  // If no timeslot in state, go back home
  if (!state.timeslot) {
    router.push(STEP_ADDRESS_URL);
    return null;
  }

  return (
    <>
      <Box>
        <Grid container spacing={5}>
          <Grid item xs={12} md={5}>
            <div className={classes.successTitle}>
              <Typography className={classes.textTitle} color="secondary" variant="h2">
                {title}
              </Typography>
              <YellowDash />
            </div>
            <Typography variant="body2">
              La reprise de votre appareil est programmée pour
              <b>
                <span> {formatDate(state.timeslot.beginning)}</span> Entre{" "}
                {moment(state.timeslot.beginning).format("H")}h et {moment(state.timeslot.end).format("H")}h.
              </b>
            </Typography>
            <Box mt={2} mb={2}>
              <Typography variant="body2">Vous allez bientôt recevoir un mail de confirmation.</Typography>
            </Box>
            {state.deliveryItems && <CollectProductRecap deliveryItems={state.deliveryItems} />}
          </Grid>
          {!isTablet && (
            <Grid item xs={12} md={7}>
              <div className={classes.relative}>
                <img src="/rendez-vous-collecte/YellowDots.svg" className={classes.dots} alt="" />
                <div className={classes.smile}>
                  <Box mb={2}>
                    <span className={classes.countdown}>
                      J-{moment(state.timeslot.beginning).startOf("day").diff(moment().startOf("day"), "days")}
                    </span>
                  </Box>
                  <Smile />
                </div>
                <img src="/rendez-vous-collecte/success.jpg" className={classes.img} alt="" />
              </div>
            </Grid>
          )}
        </Grid>
      </Box>
    </>
  );
};

const useStyles = makeStyles((theme) => ({
  successTitle: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up("md")]: {
      marginTop: theme.spacing(17),
    },
  },
  textTitle: {
    fontWeight: "bold",
    fontSize: 32,
    [theme.breakpoints.up("md")]: {
      fontSize: 40,
    },
  },
  relative: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: 432,
    marginTop: theme.spacing(0),
    [theme.breakpoints.up("md")]: {
      marginTop: theme.spacing(8),
    },
  },
  dots: {
    left: theme.spacing(4),
    position: "absolute",
    top: 0,
    "& > path": {
      fill: theme.palette.yellow,
    },
  },
  countdown: {
    fontSize: 56,
    color: theme.palette.secondary.main,
    fontWeight: 900,
  },
  img: {
    zIndex: 1,
    maxWidth: 386,
    maxHeight: 264,
    width: "100%",
  },
  smile: {
    zIndex: 2,
    boxShadow: "0px 0px 3px rgba(0, 0, 0, 0.08), 32px 41px 63px rgba(0, 0, 0, 0.2)",
    width: 218,
    left: 0,
    top: theme.spacing(4),
    height: 206,
    position: "absolute",
    backgroundColor: theme.palette.yellow,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
}));
